<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ประเภทพนักงาน</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!employeeTypeFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee_type:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddEmployeeTypeForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มประเภทพนักงาน
          </v-btn>
          <v-menu min-width="200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list nav dense>
              <v-list-item
                link
                :disabled="
                  uiCtrl &&
                  !uiCtrl.isEnable(
                    'btn:::import_data:import_csv:employee_type:post'
                  )
                "
                @click="uploadDialog = true"
              >
                <v-list-item-icon>
                  <v-icon>mdi-import</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>นำเข้าข้อมูล</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="employeeTypes"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.employment_type="{ item }">
        <span>
          {{ item.employment_type_id === 0 ? 'รายเดือน' : 'รายวัน' }}
        </span>
      </template>
    </v-data-table>
    <EmployeeTypeForm
      :formShow="employeeTypeFormShow"
      :formAction="employeeTypeFormAction"
      :employeeType="employeeType"
      :employeeTypeInit="employeeTypeInit"
      @isEmployeeTypeDataChange="handleEmployeeTypeFormDataChange"
      @formActionCompleted="handleEmployeeTypeFormActionCompleted"
      @onReset="handleEmployeeTypeFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="employeeTypeFormShow && employeeTypeFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
    <UploadDialog
      :uploadDialog="uploadDialog"
      uploadDialogTitle="นำเข้าข้อมูลประเภทพนักงาน"
      :downloadExampleFileImportDataUrl="exampleFileImportDataUrl"
      downloadExampleFileImportDataName="employeeType.csv"
      @selectedFile="selectedFile"
      @handleCancelUploadDialog="handleCancelUploadDialog"
      @uploadFile="uploadFile"
    />
    <UploadDialogMessage
      :uploadDialogMessage="uploadDialogMessage"
      uploadDialogMessageTitle="นำเข้าข้อมูลประเภทพนักงานไม่สำเร็จ"
      :downloadFileImportDataUrl="fileImportDataUrl"
      :downloadFileImportDataName="fileImportDataName"
      @onClose="uploadDialogMessage = false"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import UploadDialog from '@/components/UploadDialog.vue'
import UploadDialogMessage from '@/components/UploadDialogMessage.vue'
import EmployeeTypeForm from '@/views/employeeType/EmployeeTypeForm.vue'

export default {
  components: {
    EmployeeTypeForm,
    ConfirmDialog,
    UploadDialog,
    UploadDialogMessage,
  },
  data() {
    return {
      dialogForbidden: false,
      fileImportDataUrl: '',
      fileImportDataName: '',
      dialogProgress: false,
      progressValue: 0,
      sortBy: ['employee_type_code'],
      sortDesc: [false],
      currentFile: null,
      uploadDialog: false,
      uploadDialogMessage: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'รหัสประเภทพนักงาน',
          align: 'start',
          value: 'employee_type_code',
          width: 200,
        },
        { text: 'ชื่อประเภทพนักงาน', value: 'title_th' },
        { text: 'ชื่อประเภทพนักงาน (อังกฤษ)', value: 'title_en' },
        { text: 'คำนวณการทำงาน', value: 'employment_type' },
      ],
      employeeTypeFormShow: false,
      employeeTypeFormAction: '',
      employeeType: {},
      employeeTypeInit: {},
      isEmployeeTypeDataChange: false,
      interval: null,
      timeout: null,
      timeouts: [],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    employeeTypes() {
      return this.$store.state.employeeType.employeeTypes
    },
    exampleFileImportDataUrl() {
      return this.$store.state.download.exampleFileImportDataUrl
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ประเภทพนักงาน',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchEmployeeTypes: 'employeeType/fetchEmployeeTypes',
      uploadFileImportData: 'upload/uploadFileImportData',
      downloadExampleFileImportData: 'download/downloadExampleFileImportData',
      generateFileProgress: 'download/generateFileProgress',
    }),
    showSnackbar(type, message, timeout = -1) {
      const colors = {
        success: 'success',
        error: 'error',
        warning: 'warning',
      }

      const snackbar = {
        show: true,
        color: colors[type] || 'info',
        timeout:
          type === 'success' ? (timeout === -1 ? 3000 : timeout) : timeout,
        message,
      }

      this.$store.commit('SET_SNACKBAR', snackbar)
    },
    showErrorSnackbar(error) {
      const message = error?.response?.data?.message || 'Something went wrong!'
      this.showSnackbar('error', message)
    },
    showSuccessSnackbar(message, timeout = 3000) {
      this.showSnackbar('success', message, timeout)
    },
    selectedFile(file) {
      this.currentFile = file
    },
    handleCancelUploadDialog(refs) {
      this.uploadDialog = false
      this.currentFile = null
      refs.clearableCallback()
    },
    uploadFile(refs) {
      if (this.currentFile) {
        let formData = new FormData()
        formData.append('file', this.currentFile)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          uuid: company_uuid,
          fileType: 'employee-type',
          formData: formData,
        }

        this.$store.commit('SET_LOADING', true)

        this.uploadFileImportData(payload)
          .then((data) => {
            this.$store.commit('SET_LOADING', false)
            this.uploadDialog = false
            refs.clearableCallback()

            this.progressValue = 0
            this.dialogProgress = true
            this.uploadProgress(data.job_process_uuid, data.ping_after_ms)
          })
          .catch((error) => {
            this.$store.commit('SET_LOADING', false)
            this.uploadDialog = false

            this.showErrorSnackbar(error)
          })
      } else {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกไฟล์ใด',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    uploadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.is_success) {
              this.progressValue = 100

              this.timeouts.push(
                setTimeout(() => {
                  this.dialogProgress = false
                }, 200)
              )

              clearInterval(this.interval)

              if (res.resource_json?.total_fail > 0) {
                const fileUrl = res.resource_uri || ''
                const fileName = fileUrl
                  ? fileUrl.split('/').pop()
                  : 'error.csv'

                this.fileImportDataUrl = fileUrl
                this.fileImportDataName = fileName

                this.timeouts.push(
                  setTimeout(() => {
                    this.uploadDialogMessage = true
                  }, 300)
                )
              } else {
                this.loadData()

                this.timeouts.push(
                  setTimeout(() => {
                    this.showSuccessSnackbar('นำเข้าข้อมูลสำเร็จ')
                  }, 300)
                )
              }
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            clearInterval(this.interval)
            this.dialogProgress = false

            this.showErrorSnackbar(error)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
    classRowSelected(row) {
      if (this.employeeType.employee_type_uuid === row.employee_type_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::employee_type:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.employeeType.employee_type_uuid === row.employee_type_uuid) {
        this.employeeTypeFormShow = false
        this.employeeTypeFormAction = ''
        this.employeeType = {}
        this.employeeTypeInit = {}
      } else {
        this.employeeTypeFormShow = true
        this.employeeTypeFormAction = 'edit'
        this.employeeType = { ...row }
        this.employeeTypeInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isEmployeeTypeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddEmployeeTypeForm() {
      this.employeeTypeFormShow = true
      this.employeeTypeFormAction = 'add'
      this.employeeType = {}
      this.employeeTypeInit = {}
    },
    handleEmployeeTypeFormDataChange(value) {
      this.isEmployeeTypeDataChange = value
    },
    handleEmployeeTypeFormReset(formAction) {
      if (formAction === 'edit')
        this.employeeType = { ...this.employeeTypeInit }
    },
    handleEmployeeTypeFormActionCompleted(formAction) {
      this.employeeType = {}
      this.employeeTypeInit = {}
      this.employeeTypeFormShow = false
      this.employeeTypeFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = { company_uuid }
      const employeeTypes = this.fetchEmployeeTypes(payload)

      const downloadExampleFileImportData = this.downloadExampleFileImportData({
        uuid: company_uuid,
        exampleFileType: 'employee-type',
      })

      Promise.all([employeeTypes, downloadExampleFileImportData])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          this.showErrorSnackbar(error)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.employeeTypeFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEmployeeTypeDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }

    this.timeouts.forEach((timeout) => clearTimeout(timeout))
    this.timeouts = []
  },
}
</script>
